import { DeleteAccountComponent } from './layouts/delete-account/delete-account.component';
import { CookiePolicyComponent } from './layouts/cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './layouts/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './layouts/terms-of-use/terms-of-use.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModernComponent } from './layouts/modern/modern.component';
export const routes: Routes = [
  {
    path: 'modern',
    component: ModernComponent,
  },
  { path: 'terms-of-use', component: TermsOfUseComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'cookies-policy', component: CookiePolicyComponent },
  { path: 'delete-account', component: DeleteAccountComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
